
var React = require("react");

class ExternalLinkButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
        const { 
            link, 
            text,
            style,
            onClick, 
            addedClass = ""
        } = this.props;
        
        return <a className={`button ${addedClass}`} style={style}
             href={link} 
             target="_blank">
                <p onClick={onClick}>
                    {text}
                </p>
            </a>
    }
}

module.exports = ExternalLinkButton;